import { Injectable } from '@angular/core';

type CsvValue = { displayName: string, value: any };
type CsvConfig = { nullSubstitute: string };

export type CsvTable = { title: string; data: { [key: string]: any }[] };

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor() { }

  downloadCSV(filename: string, data: Map<string, CsvValue>[], valuesToIgnore: string[], config: CsvConfig): void {
    const csvContent = this.convertArrayToCSV(data, valuesToIgnore, config);
    this.downloadFromResponse(csvContent, filename);
  }

  downloadMultiTableCSV(filename: string, tables: CsvTable[]): void {
    const csvContent = this.convertMultipleTablesToCSV(tables);
    this.downloadFromResponse(csvContent, filename);
  }

  convertArrayToCSV(data: Map<string, CsvValue>[], valuesToIgnore: string[], config: CsvConfig): string {
    const cleanedData = data.map(item => new Map<string, CsvValue>(
      Array.from(item.entries()).filter(([key]) => !valuesToIgnore.includes(key)))
    );

    const headers = Array.from(cleanedData[0].values()).map(value => value.displayName).join(",");
    const rows = cleanedData.map((row) =>
        Array.from(row.values())
            .map((value) => `"${value.value ?? config.nullSubstitute}"`) // Escape values
            .join(",")
    );
    return `${headers}\n${rows.join("\n")}\n\n`;
  }

  convertMultipleTablesToCSV(tables: CsvTable[]): string {
    let csvContent = '';

    tables.forEach((table) => {
      if (table.title) {
        csvContent += `${table.title}\n`;
      }

      if (table.data && table.data.length) {
        const headers = Object.keys(table.data[0]).join(',');
        const rows = table.data.map((row) =>
          Object.values(row)
            .map((value) => `"${value}"`)
            .join(',')
        );

        csvContent += [headers, ...rows].join('\n') + '\n\n';
      }
    });

    return csvContent.trim();
  }

  downloadFromResponse(csvContent: string, filename: string): void {
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename + ".csv";
        a.click();

        window.URL.revokeObjectURL(url);
  }
}